{
  "name": "macrotide-web",
  "private": true,
  "version": "0.1.0",
  "type": "module",
  "engines": {
    "node": ">=22.12"
  },
  "scripts": {
    "shared": "cd ../.. && ./gradlew :shared:jsNodeProductionLibraryDistribution",
    "dev": "vite",
    "build": "tsc -b && vite build",
    "preview": "vite preview",
    "typecheck": "tsc -b",
    "lint": "eslint .",
    "test": "vitest run",
    "i18n:extract": "lingui extract",
    "i18n:compile": "lingui compile --typescript"
  },
  "dependencies": {
    "@lingui/core": "6.11.0",
    "@lingui/react": "6.11.0",
    "@mantine/core": "9.6.3",
    "@mantine/hooks": "9.6.3",
    "@mantine/notifications": "9.6.3",
    "@tanstack/react-query": "5.104.1",
    "@tanstack/react-router": "1.170.41",
    "macrotide-shared": "file:../../shared/build/dist/js/productionLibrary",
    "react": "19.3.0",
    "react-dom": "19.3.0",
    "recharts": "3.10.1"
  },
  "devDependencies": {
    "@eslint/js": "10.0.1",
    "@lingui/cli": "6.11.0",
    "@lingui/vite-plugin": "6.11.0",
    "@testing-library/react": "^16.3.3",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "6.1.1",
    "eslint": "10.12.0",
    "eslint-plugin-lingui": "0.16.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "globals": "17.13.0",
    "jsdom": "^30.1.3",
    "typescript": "6.0.3",
    "typescript-eslint": "8.71.0",
    "vite": "8.3.2",
    "vitest": "5.0.3"
  }
}
